import InfoTenantProfile from './InfoTenantProfile'

export default InfoTenantProfile
